import { aboutButtons, aboutMariaText } from "i18n/about";
import { ClientandPartnerButton, ClientandPartnerText } from "i18n/client";
import { BusinessEventText } from "i18n/Events";
import { ArrowUpLeft, ArrowUpRight, CheckCircle2 } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MainEvent = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = BusinessEventText[lang];

  const navigate = useNavigate();

  return (
    <section className="bg-[#f5f5f3] py-16 md:py-24">
      <div className="max-w-5xl mx-auto text-[#111] px-6">
        {/* Title */}
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-[Crimson] uppercase tracking-wide text-reddark font-semibold">
            {t.title}
          </h2>
        </div>

        {/* Intro */}
        <div className="space-y-6">
          {t.intro.map((p, i) => (
            <div
              key={i}
              className="
        group flex items-start gap-4
        rounded-3xl
        bg-white/80
        border border-white
        backdrop-blur-xl
        p-6 md:p-7
        shadow-[0_10px_40px_rgba(0,0,0,0.04)]
        hover:-translate-y-1
        hover:shadow-[0_20px_50px_rgba(0,0,0,0.06)]
        transition-all duration-500
      "
            >
              {/* Icon */}
              <div
                className="
          shrink-0
          w-12 h-12
          rounded-2xl
          bg-reddark/10
          flex items-center justify-center
        "
              >
                <ArrowUpLeft className="w-6 h-6 text-reddark" />
              </div>

              {/* Text */}
              <p className="text-base md:text-lg leading-relaxed text-[#222]">
                {p}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Highlight */}

      <div className="text-center mb-14 mt-14">
        <h2 className="text-2xl md:text-4xl font-[Crimson] uppercase tracking-wide text-reddark font-semibold">
          {t.secondTitle}
        </h2>
      </div>

      {/* Body */}
      <div className="max-w-5xl mx-auto px-6">
        <div className="space-y-6">
          {t.body.map((p, i) => (
            <div
              key={i}
              className="
          group flex items-start gap-4
          rounded-3xl
          bg-white/80
          border border-white
          backdrop-blur-xl
          p-6 md:p-7
          shadow-[0_10px_40px_rgba(0,0,0,0.04)]
          hover:-translate-y-1
          hover:shadow-[0_20px_50px_rgba(0,0,0,0.06)]
          transition-all duration-500
        "
            >
              {/* Icon */}
              <div
                className="
            shrink-0
            w-12 h-12
            rounded-2xl
            bg-reddark/10
            flex items-center justify-center
          "
              >
                <ArrowUpRight className="w-6 h-6 text-reddark" />
              </div>

              {/* Text */}
              <p className="text-base md:text-lg leading-relaxed text-[#222]">
                {p}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainEvent;
